import { Route } from "react-router-dom";
import { CreatePointOfContacts, PointOfContactList, UpdatePointOfContacts } from "../PointOfContacts/PointOfContacts";

export const POINT_OF_CONTACT_ROUTES = [
    <Route key="poc-list" path="/point_of_contact/list" element={<PointOfContactList />} />,
    <Route key="poc-create" path="/point_of_contact/create" element={<CreatePointOfContacts />} />,
    <Route key="poc-update" path="/point_of_contact/update/:id" element={<UpdatePointOfContacts />} />
];
